'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxModulesPost = require('redux/modules/post');

var _reduxModulesDetails = require('redux/modules/details');

var _reduxAsyncConnect = require('redux-async-connect');

var _utils = require('../../utils');

var _components2 = require('components');

var _components = {
  _$Post: {
    displayName: 'Post'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/Post/Post.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/containers/Post/Post.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var Post = (function (_Component) {
  _inherits(Post, _Component);

  function Post() {
    _classCallCheck(this, _Post);

    _Component.apply(this, arguments);
  }

  Post.prototype.renderPostHead = function renderPostHead() {
    var _props = this.props;
    var post = _props.post;
    var loading = _props.loading;

    if (loading) {
      return _react2['default'].createElement(_reactHelmet2['default'], { title: '' });
    }

    return _react2['default'].createElement(_reactHelmet2['default'], {
      title: post[0].title.rendered,
      meta: [{ 'name': 'description', 'content': _utils.striptags(post[0].excerpt.rendered) }, { 'property': 'og:title', 'content': _utils.striptags(post[0].title.rendered) }, { 'property': 'og:description', 'content': _utils.striptags(post[0].excerpt.rendered) }, { 'property': 'og:image', 'content': _utils.striptags(post[0].featured_image) }]
    });
  };

  Post.prototype.renderPostHero = function renderPostHero() {
    var _props2 = this.props;
    var post = _props2.post;
    var loading = _props2.loading;

    if (loading) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'light' });
    }

    return _react2['default'].createElement(_components2.PostHero, { post: post[0] });
  };

  Post.prototype.renderPostContent = function renderPostContent() {
    var _props3 = this.props;
    var post = _props3.post;
    var loading = _props3.loading;

    if (loading) {
      return _react2['default'].createElement(_components2.AppLoader, null);
    }

    return _react2['default'].createElement(_components2.PostContent, { post: post[0] });
  };

  Post.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      null,
      this.renderPostHead(),
      _react2['default'].createElement(
        'section',
        { className: 'page-hero' },
        this.renderPostHero()
      ),
      _react2['default'].createElement(
        'section',
        { className: 'page-content' },
        this.renderPostContent()
      )
    );
  };

  _createClass(Post, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.array,
      loading: _react.PropTypes.bool.isRequired,
      loaded: _react.PropTypes.bool.isRequired
    },
    enumerable: true
  }]);

  var _Post = Post;
  Post = _wrapComponent('_$Post')(Post) || Post;
  Post = _reactRedux.connect(function (state) {
    return {
      post: state.post.data,
      loading: state.post.loading,
      loaded: state.post.loaded
    };
  })(Post) || Post;
  Post = _reduxAsyncConnect.asyncConnect([{
    deferred: true,
    promise: function promise(_ref) {
      var _ref$store = _ref.store;
      var dispatch = _ref$store.dispatch;
      var getState = _ref$store.getState;
      var params = _ref.params;

      var promises = [];
      var state = getState();
      var pagePath = state.routing.locationBeforeTransitions.pathname;
      var postId = params.postId;

      if (!_reduxModulesPost.isLoaded(state, postId)) {
        promises.push(dispatch(_reduxModulesPost.load(postId)));
      }

      if (!_reduxModulesDetails.isLoaded(state, postId)) {
        promises.push(dispatch(_reduxModulesDetails.load(pagePath, postId)));
      }

      return _Promise.all(promises);
    }
  }])(Post) || Post;
  return Post;
})(_react.Component);

exports['default'] = Post;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Post/Post.js
// module id = 677
// module chunks = 0